import { HelpItem, HelpItemAction } from '@cash-web/protos/squareup/franklin/api/help_item.pb'
import logger from '@cash-web/shared/util-logger'
import { getSupportedInternalRouteInfo } from '@cash-web/shared-util-route-info'

export const UNSUPPORTED_HELP_ITEM_ACTIONS = [
  HelpItemAction.START_SUPPORT_FLOW,
  HelpItemAction.SHOW_MESSAGE,
  HelpItemAction.RESOLVE_MERGE_FALSE,
]

export function getSupportedHelpItems(items?: HelpItem[]): HelpItem[] | undefined {
  const supportedItems = items?.filter(item => {
    if (UNSUPPORTED_HELP_ITEM_ACTIONS.includes(item.action as HelpItemAction)) {
      return false
    } else if (item.action === HelpItemAction.BLOCKER_ACTION) {
      const clientRoute = item.blocker_action?.internal_navigation_action?.client_route?.url
      if (clientRoute) {
        const isSupported = getSupportedInternalRouteInfo(clientRoute) !== undefined
        if (!isSupported) {
          logger.warn(new Error(`Unsupported HelpItemAction filtered out with client route url: ${clientRoute}}`))
          return false
        }
      }
    }

    return true
  })

  return supportedItems
}
